import { Attivazione, getStepNumber, Status } from './../../../models/attivazione';
import { AlgAttivazioniService } from './../../../services/alg-attivazioni.service';
import { Component, OnInit, Input, ViewChild, ElementRef, SimpleChanges } from '@angular/core';

@Component({
  selector: 'alg-attivazioni-step',
  templateUrl: './alg-attivazioni-step.component.html',
  styleUrls: ['./alg-attivazioni-step.component.scss']
})
export class AlgAttivazioniStepComponent implements OnInit {

  @Input() step: any;
  public status: string = 'disable';
  @ViewChild('accordion') private accordion;
  public attivazione: Attivazione;
  constructor(
    private api: AlgAttivazioniService,
    private element: ElementRef
  ) { }

  ngOnInit() {    
    this.api.currentStep.subscribe((webStatus: Status) => {
      this.setStatus(webStatus);
    });
    this.api.attivazione$
    .subscribe((attivazione) => {
        if (!attivazione) {
            return;
        }
        this.attivazione = attivazione;
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.step) {
      this.setStatus(changes.step.currentValue);
    }
  }

  private setStatus(step) {
    if (this.step.name === step) {
      setTimeout(() => {
        const stepPosition = (this.element.nativeElement as HTMLElement).offsetTop;
        window.scroll({
          top: stepPosition,
          behavior: 'smooth'
        });
      }, 50);
      this.status = 'active';
      this.accordion.open();
    }
    if (getStepNumber(step) > getStepNumber(this.step.name)) {
      this.status = 'completed';
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/alg-attivazioni/alg-attivazioni-step/alg-attivazioni-step.component.ts